export const c_tree_view__list_item_m_expanded__node_toggle_Color = {
  "name": "--pf-c-tree-view__list-item--m-expanded__node-toggle--Color",
  "value": "#151515",
  "var": "var(--pf-c-tree-view__list-item--m-expanded__node-toggle--Color)"
};
export default c_tree_view__list_item_m_expanded__node_toggle_Color;